'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetSetupForTests = exports.setupStyledComponents = undefined;

var _domReady = require('./domReady');

var _Dom = require('../utils/Dom');

var SC_ATTR = 'data-hubspot-styled-components'; // Custom for our styled-components repackage

var hasSetupStyledComponents = false;
var oneTimeSetupStyledComponents = function oneTimeSetupStyledComponents() {
  if (hasSetupStyledComponents) return;
  if (!document.head) return;

  var styledComponentsStylesTags = Array.prototype.slice.apply(document.head.querySelectorAll('style[' + SC_ATTR + ']'));
  if (styledComponentsStylesTags.length > 0) {
    // Move all styled-components <style> tags to the start of the <head>, preserving their order.
    styledComponentsStylesTags.reverse().forEach(function (tag) {
      document.head.removeChild(tag);
      (0, _Dom.prepend)(document.head, tag);
    });
  } else {
    // Create a placeholder styled-components <style> tag at the start of the <head>.
    var newTag = document.createElement('style');
    newTag.setAttribute('type', 'text/css');
    newTag.setAttribute(SC_ATTR, '');
    newTag.setAttribute('data-styled-components-is-local', 'true');
    (0, _Dom.prepend)(document.head, newTag);
  }

  hasSetupStyledComponents = true;
};

var setupStyledComponents = exports.setupStyledComponents = function setupStyledComponents() {
  (0, _domReady.domReady)(function () {
    setTimeout(oneTimeSetupStyledComponents, 0); // Ensure that this method runs in its own tick
  });
};

var resetSetupForTests = exports.resetSetupForTests = function resetSetupForTests() {
  hasSetupStyledComponents = false;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/listeners/setupStyledComponents.js
// module id = 78
// module chunks = 0